<script lang="ts">
    import Icon from '@iconify/svelte'

    import { type TGettext, resolve } from 'hydria/services/gettext'

    interface Props {
        label: TGettext
        isPristine: boolean
        isValid: boolean
        simpleMode?: boolean
        children?: import('svelte').Snippet
    }

    let { label, isPristine, isValid, simpleMode = false, children }: Props = $props()

    let statusIcon: string = $derived(isPristine ? 'mdi:check-circle' : isValid ? 'mdi:liquid-spot' : 'mdi-alert')
    let statusClass: string = $derived(isPristine ? 'text-muted' : isValid ? 'text-warning' : 'text-danger')
</script>

<style>
    .title {
        color: var(--bs-secondary);
    }
    .group {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto 1fr;
        height: 100%;
        align-items: center;
        justify-items: stretch;
        gap: 0.1rem;
    }
    .title {
        display: flex;
        align-items: center;
        border-bottom: 1px solid var(--bs-gray-300);
    }
    .title > :first-child {
        flex: 1 0 0;
    }
    .content {
        text-align: center;
    }
</style>

{#if simpleMode}
    {@render children?.()}
{:else}
    <div class="group">
        <div class="title">
            <div><small>{$resolve(label)}</small></div>
            <div>
                <small class={statusClass}><Icon inline icon={statusIcon} /></small>
            </div>
        </div>
        <div class="content">
            {@render children?.()}
        </div>
    </div>
{/if}
